import { render, staticRenderFns } from "./MenuAdministration.vue?vue&type=template&id=223d5214&"
import script from "./MenuAdministration.vue?vue&type=script&lang=ts&"
export * from "./MenuAdministration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports